module.exports = __webpack_public_path__ + "media/กูแก่แล้วไอ้สัส.35314027.mp3";